import React, { useState, useRef } from "react";
import tsukaikata from "./metadatas/meta_howto_old_20220803.js";
import tsukaikata2 from "./metadatas/meta_howto_20260209.js";
import howto_1 from "../img/howto_1.webp";
import howto_2 from "../img/howto_2.webp";
import howto_3 from "../img/howto_3.webp";
// import howto_4 from "../img/howto_4.webp";
import howto_5 from "../img/howto_5.webp";
import howto_6 from "../img/howto_6.webp";

import Typewriter from "typewriter-effect";
import { GeographHeader } from "./panels/geographHeader.js";
// import { GeographFooter } from "./panels/geographFooter.js";
import { TojiruX } from "./buttons/tojiruX.js";

const Panel = ({ img, title, subtitle, description, themenum }) => {
  return (
    <>
      <div
        className="
          cursor-pointer
          bg-white
          shadow-md
          h-[40vh]
          rounded-3xl
          flex flex-col
          justify-around
          items-center
          overflow-hidden
          sm:flex-row sm:h-[23vh]
          lg:w-[48vw] mx-[1vw] my-[1vh]
        "
      >
        <img
          className="h-1/2 w-full sm:h-full sm:w-5/12 object-contain"
          src={img}
          alt="panel"
        />
        <div
          className="
            flex-1
            w-full
            flex flex-col
            items-baseline
            justify-around
            h-1/2
            pl-6
            sm:h-full sm:items-baseline sm:w-1/2
          "
        >
          <div className="flex flex-col justify-start items-baseline">
            <h1 className="text-4xl font-normal mb-0 text-gray-600 font-sans">
              {title}
            </h1>
            <span className="text-xs text-indigo-300 mt-0">{subtitle}</span>
          </div>
          <p className="text-xs text-gray-500 w-4/5">{description}</p>
          <div className="w-full flex justify-between items-center">
            <h1 className="font-bold text-gray-500">{themenum}</h1>
            <button className="bg-gray-700 mr-5 text-white px-3 py-1 rounded-sm shadow-md">
              選択
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export const Howto = () => {
  const [count, setCount] = useState(0);
  const [popup, setPopup] = useState(0);
  const ref = useRef("");

  ref.current = "";

  function msgwindow(text) {
    return (
      <Typewriter
        options={{
          strings: text,
          autoStart: true,
          delay: 10,
          // loop: true,
          onCreateTextNode: (character, textNode) => {
            ref.current += character;
            return textNode;
          },
        }}
      />
    );
  }

  let scene_image;
  scene_image = `/img/${tsukaikata2[count].scene_image}.webp`;
  let chara_image;
  chara_image = `/img/${tsukaikata2[count].chara_image}.webp`;

  return (
    <>
      <GeographHeader />
      <div className="h-12 md:h-14 pointer-events-none"></div>

      <div className="absolute z-30 bg-gradient-to-r from-white/90 via-white/100 to-white/90 px-0 h-[calc(100vh-48px)] md:h-[calc(100vh-56px)] w-full overflow-auto text-gray-800">
        <TojiruX />

        <>
          <div>
            <div className="absolute z-30 font-mono text-black w-full h-screen bg-blue-100">
              <div className="mt-2 text-2xl text-left w-full text-black text-extrabold bg-gradient-to-r from-cyan-200 to-blue-400 hover:bg-gradient-to-bl focus:ring-4 focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium px-5 py-2.5">
                ジオグラフの使い方：操作方法の説明や実践事例をご覧になれます
              </div>
              <div className="lg:flex lg:flex-wrap w-full min-h-[76vh]">
                <div
                  onClick={() => {
                    setPopup(1);
                    setCount(0);
                  }}
                >
                  <Panel
                    img="img/使い方紙芝居_サムネイル用.webp"
                    title="使い方（紙芝居）"
                    subtitle="tutorial"
                    description=""
                    themenum=""
                  />
                </div>

                <div onClick={() => setPopup(2)}>
                  <Panel
                    img="img/使い方マニュアル_サムネイル用.webp"
                    title="使い方（マニュアル）"
                    subtitle="manual"
                    description=""
                    themenum=""
                  />
                </div>

                <div onClick={() => setPopup(3)}>
                  <Panel
                    img="img/実践事例_サムネイル.webp"
                    title="実践事例"
                    subtitle="practical examples"
                    description=""
                    themenum=""
                  />
                </div>
                <a href="/faq">
                  <Panel
                    img="img/FAQ_サムネイル.webp"
                    title="FAQ"
                    subtitle="Frequently asked questions"
                    description=""
                    themenum=""
                  />
                </a>
              </div>
            </div>
          </div>
        </>
      </div>

      {popup == 3 && (
        <>
          <>
            <div
              className="absolute z-30 bg-black/50 w-full h-full"
              onClick={() => setPopup(0)}
            ></div>

            <div className="absolute z-50 max-h-full font-mono text-black bg-black w-[90%] mx-[5%]">
              <div className="absolute z-20 bg-gradient-to-r from-white/90 via-white to-white/90 px-10 max-h-[calc(100vh-80px)] w-full overflow-auto">
                <section className="container mx-auto px-6 p-10">
                  <div
                    onClick={() => setPopup(0)}
                    className="absolute top-5 right-5 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </div>
                  <h2 className="text-4xl font-bold text-center text-gray-800 mb-2">
                    記事一覧
                  </h2>
                  <div className="flex items-center flex-wrap mb-0 text-center">
                    <a
                      href="pdf/地域課題の発見と解決へ.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          地域課題の発見と解決へ
                          <br />
                          ～学びの力で社会に貢献しようとする中学生の挑戦～
                        </h4>
                        <p className="text-gray-600 mb-0">
                          船橋市立葛飾中学校 教諭 歌津 文也
                        </p>
                      </div>
                    </a>

                    <a
                      href="/pdf/学習上のGIS活用の入門的指導.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          学習上のGIS活用の入門的指導
                          <br />
                        </h4>
                        <p className="text-gray-600 mb-0">
                          拓殖大学 非常勤講師 池下 誠
                        </p>
                      </div>
                    </a>
                    <a
                      href="/pdf/高等学校 地理  探究型学習スタートアップ.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          高等学校 地理 探究型学習スタートアップ
                          <br />
                          ～地球観測衛星データの3次元メッシュマップを用いて～
                        </h4>
                        <p className="text-gray-600 mb-0">
                          品川女子学院 教諭 河合 豊明
                        </p>
                      </div>
                    </a>
                    <a
                      href="/pdf/中学校社会科「地域の在り方」単元の実践.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          中学校社会科「地域の在り方」単元の実践
                          <br />
                          ～JAXAデータをもとに深める、持続可能な社会の実現に向けた考察力～
                        </h4>
                        <p className="text-gray-600 mb-0">
                          新潟県 上越教育大学附属中学校 教諭 仙田 健一
                        </p>
                      </div>
                    </a>
                    <a
                      href="https://www.teikokushoin.co.jp/files/common/%E3%80%8C%E5%9C%B0%E5%9F%9F%E3%81%AE%E5%9C%A8%E3%82%8A%E6%96%B9%E3%80%8D%E5%8D%98%E5%85%83%E3%81%A0%E3%81%8B%E3%82%89%E3%81%93%E3%81%9D%E8%82%B2%E3%81%BE%E3%82%8C%E3%82%8B%E3%82%B3%E3%83%B3%E3%83%94%E3%83%86%E3%83%B3%E3%82%B7%E3%83%BC%E3%80%81%E5%B0%86%E6%9D%A5%E3%82%92%E7%94%9F%E3%81%8D%E3%82%8B%E5%8A%9B%20%EF%BD%9E%E3%83%95%E3%82%A3%E3%83%BC%E3%83%AB%E3%83%89%E3%83%AF%E3%83%BC%E3%82%AF%E3%81%A8%20ICT%20%E5%88%A9%E6%B4%BB%E7%94%A8%E3%81%AE%E8%A4%87%E5%90%88%E3%81%8C%E5%8A%A0%E9%80%9F%E3%81%95%E3%81%9B%E3%82%8B%E3%80%81%E8%80%83%E5%AF%9F%E3%83%BB%E8%AD%B0%E8%AB%96%E3%83%BB%E6%A7%8B%E6%83%B3%EF%BD%9E.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          「地域の在り方」単元だからこそ育まれるコンピテンシー、将来を生きる力
                          <br />
                          ～フィールドワークとICT利活用の複合が加速させる、考察・議論・構想～
                        </h4>
                        <p className="text-gray-600 mb-0">
                          新潟県 上越教育大学附属中学校 教諭 仙田健一
                        </p>
                      </div>
                    </a>
                    <a
                      href="https://www.geograph.teikokushoin.co.jp/pdf/ICT利活用で拓く中山間部校の探究的な学び.pdf"
                      // href="pdf/ICT利活用で拓く中山間部校の探究的な学び.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          ICT利活用で拓く、中山間部校の探究的な学び
                          {/* <br />
                          ～フィールドワークとICT利活用の複合が加速させる、考察・議論・構想～ */}
                        </h4>
                        <p className="text-gray-600 mb-0">
                          兵庫県 丹波市立柏原中学校 主幹教諭 高木 聡子
                        </p>
                      </div>
                    </a>
                    <a
                      href="pdf/ジオグラフ_活用場面_中学校社会科_20231003.pdf"
                      target="_blank"
                      className="mt-5 flex items-center bg-blue-100 p-5 rounded-3xl hover:border-transparent hover:bg-blue-200 w-full"
                    >
                      <div className="w-full">
                        <h4 className="text-xl text-gray-800 font-bold mb-3">
                          ジオグラフ活用場面（中学校社会科）
                        </h4>
                        <p className="text-gray-600 mb-0">
                          (株)帝国書院 研究室
                        </p>
                      </div>
                    </a>
                  </div>
                </section>
                <h2 className="text-xl font-bold px-2">
                  <button
                    className="bg-black text-white py-3 px-10 rounded-xl"
                    onClick={() => setPopup(0)}
                  >
                    戻る
                  </button>
                </h2>
                <div className="h-20"></div>
              </div>
            </div>
          </>
        </>
      )}

      {popup == 1 && (
        <>
          <>
            <div
              className="absolute z-30 bg-black/50 w-full h-[90%]"
              onClick={() => setPopup(0)}
            ></div>

            <div className="absolute z-50 max-h-full font-mono text-black bg-black w-full">
              <div className="absolute z-20 bg-gradient-to-r from-white/90 via-white to-white/90 px-10 h-[calc(100vh-80px)] w-full overflow-auto">
                <section className="container mx-auto px-6 p-1">
                  <div
                    onClick={() => setPopup(0)}
                    className="absolute top-5 right-5 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </div>

                  {count + 1 < tsukaikata2.length && (
                    <>
                      <div className="z-40 text-left text-2xl font-bold">
                        <span className="bg-white px-5 rounded-lg select-none">
                          {tsukaikata2[count].komidashi}
                        </span>
                      </div>

                      <div className="absolute container">
                        <img
                          src={scene_image}
                          alt="geograph_howto_image"
                          className="object-center h-[calc(100vh-168px)] md:h-[calc(100vh-236px)] mx-auto rounded-2xl"
                        />
                      </div>

                      <div
                        className="text-left text-xs md:text-base lg:text-xl"
                        onClick={() => setCount(count + 1)}
                      >
                        <div className="w-full">
                          <div className="absolute inset-x-2 bottom-1 rounded-3xl border-double border-4 border-gray-600 bg-white p-4 mt-4 h-[30vh] sm:h-[20vh] cursor-pointer select-none">
                            {msgwindow(tsukaikata2[count].dialogue)}
                            {
                              <div className="absolute right-4 bottom-4 bg-black text-white px-4 rounded-xl cursor-pointer select-none">
                                <button>次へ＞</button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>

                      {count > 0 && (
                        <div
                          className={`absolute left-6 bottom-5 text-xs md:text-base lg:text-xl text-white px-4 mb-1 rounded-xl cursor-pointer select-none bg-black`}
                          onClick={() => setCount(count - 1)}
                        >
                          ＜戻る
                        </div>
                      )}
                      {count == 0 && (
                        <div
                          className={`absolute left-6 bottom-5 text-xs md:text-base lg:text-xl text-white px-4 mb-1 rounded-xl select-none bg-black/20`}
                        >
                          ＜戻る
                        </div>
                      )}

                      {tsukaikata2[count].chara_image == "chara_1" && (
                        <div className={`absolute bottom-[30vh] ${"left-0"}`}>
                          <img
                            src={chara_image}
                            alt="Monitoring"
                            className="object-center max-h-[15vh] md:max-h-[30vh] rounded-2xl"
                          />
                        </div>
                      )}
                      {tsukaikata2[count].chara_image == "chara_2" && (
                        <div className={`absolute bottom-[30vh] ${"left-0"}`}>
                          <img
                            src={chara_image}
                            alt="Monitoring"
                            className="object-center max-h-[15vh] md:max-h-[30vh] rounded-2xl"
                          />
                        </div>
                      )}
                      {tsukaikata2[count].chara_image == "chara_3" && (
                        <div className={`absolute bottom-[30vh] ${"right-0"}`}>
                          <img
                            src={chara_image}
                            alt="geograph_howto_image"
                            className="object-center max-h-[15vh] md:max-h-[30vh] rounded-2xl"
                          />
                        </div>
                      )}
                      {tsukaikata2[count].chara_image == "chara_4" && (
                        <div className={`absolute bottom-[30vh] ${"right-0"}`}>
                          <img
                            src={chara_image}
                            alt="geograph_howto_image"
                            className="object-center max-h-[15vh] md:max-h-[30vh] rounded-2xl"
                          />
                        </div>
                      )}
                    </>
                  )}

                  {count == tsukaikata2.length - 1 && (
                    <>
                      <div className="h-20 pointer-events-none"></div>
                      <div className="absolute z-50 font-mono text-white w-[80%]">
                        <div className="flex items-center justify-center">
                          <div
                            className="text-xs md:text-2xl mx-5 p-3 bg-black/80 rounded-xl cursor-pointer select-none"
                            onClick={() => setCount(count - 1)}
                          >
                            ＜戻る
                          </div>
                          <div className="text-xs md:text-2xl mx-5 p-3 bg-black/80 rounded-xl cursor-pointer select-none">
                            <a href="/select">さっそく使ってみる</a>
                          </div>
                          <div className="text-xs md:text-2xl mx-5 p-3 bg-black/80 rounded-xl cursor-pointer select-none">
                            <a href="/">ホーム</a>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </section>

                <div className="h-20"></div>
              </div>
            </div>
          </>
        </>
      )}

      {popup == 2 && (
        <>
          <>
            <div
              className="absolute z-30 bg-black/50 w-full h-full"
              onClick={() => setPopup(0)}
            ></div>

            <div className="absolute z-50 max-h-full font-mono text-black bg-black w-[90%] mx-[5%]">
              <div className="absolute z-20 bg-gradient-to-r from-white/90 via-white to-white/90 px-10 max-h-[calc(100vh-80px)] w-full overflow-auto">
                <section className="container mx-auto px-6 p-10">
                  <div
                    onClick={() => setPopup(0)}
                    className="absolute top-5 right-5 cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </div>
                  <h2 className="text-4xl font-bold text-center text-gray-800 mb-8">
                    ジオグラフの使い方
                  </h2>
                  <div className="flex items-center flex-wrap mb-20 text-left">
                    <div className="w-full md:w-1/2">
                      <h4 className="text-3xl text-gray-800 font-bold mb-3">
                        {tsukaikata[1].komidashi}
                      </h4>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[1].setsumei_1}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[1].setsumei_2}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[1].setsumei_3}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[1].setsumei_4}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[1].setsumei_5}
                      </p>
                    </div>
                    <div className="w-full md:w-1/2">
                      <div className="p-2">
                        <img
                          src={howto_1}
                          alt="Monitoring"
                          className="object-center w-full h-auto"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center flex-wrap mb-20 text-left">
                    <div className="w-full md:w-1/2">
                      <div className="p-2">
                        <img
                          src={howto_2}
                          alt="Monitoring"
                          className="object-center w-full h-auto"
                        />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 pl-10">
                      <h4 className="text-3xl text-gray-800 font-bold mb-3">
                        {tsukaikata[2].komidashi}
                      </h4>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[2].setsumei_1}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[2].setsumei_2}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[2].setsumei_3}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[2].setsumei_4}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[2].setsumei_5}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center flex-wrap mb-20 text-left">
                    <div className="w-full md:w-1/2">
                      <h4 className="text-3xl text-gray-800 font-bold mb-3">
                        {tsukaikata[3].komidashi}
                      </h4>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[3].setsumei_1}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[3].setsumei_2}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[3].setsumei_3}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[3].setsumei_4}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[3].setsumei_5}
                      </p>
                    </div>
                    <div className="w-full md:w-1/2">
                      <div className="p-2">
                        <img
                          src={howto_3}
                          alt="Monitoring"
                          className="object-center w-full h-auto"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center flex-wrap mb-20 text-left">
                    <div className="w-full md:w-1/2">
                      <div className="p-2">
                        <img
                          src={howto_6}
                          alt="Monitoring"
                          className="object-center w-full h-auto"
                        />
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 pl-10">
                      <h4 className="text-3xl text-gray-800 font-bold mb-3">
                        {tsukaikata[4].komidashi}
                      </h4>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[4].setsumei_1}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[4].setsumei_2}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[4].setsumei_3}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[4].setsumei_4}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[4].setsumei_5}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center flex-wrap mb-20 text-left">
                    <div className="w-full md:w-1/2">
                      <h4 className="text-3xl text-gray-800 font-bold mb-3">
                        {tsukaikata[5].komidashi}
                      </h4>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[5].setsumei_1}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[5].setsumei_2}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[5].setsumei_3}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[5].setsumei_4}
                      </p>
                      <p className="text-gray-600 mb-8">
                        {tsukaikata[5].setsumei_5}
                      </p>
                    </div>
                    <div className="w-full md:w-1/2">
                      <div className="p-2">
                        <a href="/select">
                          <img
                            src={howto_5}
                            alt="Monitoring"
                            className="object-center w-full h-auto"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </section>
                <h2 className="text-xl font-bold px-2">
                  <button
                    className="bg-black text-white py-3 px-10 rounded-xl"
                    onClick={() => setPopup(0)}
                  >
                    戻る
                  </button>
                </h2>
                <div className="h-20"></div>
              </div>
            </div>
          </>
        </>
      )}

      {/* <GeographFooter /> */}
    </>
  );
};
